var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "el-tabs",
            {
              staticClass: "tabs_style",
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.queryForm.params.taskTab,
                callback: function ($$v) {
                  _vm.$set(_vm.queryForm.params, "taskTab", $$v)
                },
                expression: "queryForm.params.taskTab",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: {
                  label:
                    _vm.$t("collectionCenter.todaysTasks") +
                    " (" +
                    _vm.taskTabCount.today +
                    ")",
                  name: "today",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label:
                    _vm.$t("collectionCenter.historyRecords") +
                    " (" +
                    _vm.taskTabCount.history +
                    ")",
                  name: "history",
                },
              }),
            ],
            1
          ),
          _c(
            "el-table",
            { attrs: { data: _vm.tableData, border: "", "max-height": "600" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.taskId"),
                  align: "center",
                  prop: "id",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.taskType"),
                  align: "center",
                  prop: "type",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type === 1
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v(_vm._s(_vm.$t("Resource.import"))),
                            ])
                          : scope.row.type === 2
                          ? _c("el-tag", { attrs: { type: "warning" } }, [
                              _vm._v(_vm._s(_vm.$t("Resource.export")) + " "),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.taskStatus"),
                  align: "center",
                  prop: "status",
                  width: "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 0
                          ? _c("span", [
                              _c(
                                "span",
                                { staticClass: "tag_orange" },
                                [
                                  _c("svg-icon", {
                                    attrs: { "icon-class": "hourglass" },
                                  }),
                                  _vm._v(_vm._s(_vm.$t("Resource.init"))),
                                ],
                                1
                              ),
                              _c("span", { staticClass: "tag_gray" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("collectionCenter.queueCount")
                                  ) +
                                    "：" +
                                    _vm._s(scope.row.queueCount)
                                ),
                              ]),
                            ])
                          : scope.row.status === 1
                          ? _c("span", [
                              _c(
                                "span",
                                { staticClass: "el-icon-s-tools tag_blue" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("basicData.exporting"))
                                  ),
                                ]
                              ),
                            ])
                          : scope.row.status === 2
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v(_vm._s(_vm.$t("Resource.complete")) + " "),
                            ])
                          : scope.row.status === 3
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v(_vm._s(_vm.$t("Resource.fail")) + " "),
                            ])
                          : scope.row.status === 4
                          ? _c("span", [
                              _c("span", { staticClass: "tag_gray" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("collectionCenter.cancelled"))
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.schedule"),
                  align: "center",
                  prop: "schedule",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-progress", {
                          attrs: {
                            percentage: scope.row.schedule,
                            status:
                              scope.row.schedule == 100
                                ? "success"
                                : scope.row.status === 3
                                ? "exception"
                                : "",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.total"),
                  align: "center",
                  prop: "estimateCount",
                  width: "190",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 2
                          ? _c("div", [
                              _vm._v(
                                " " + _vm._s(scope.row.successCount) + " "
                              ),
                            ])
                          : _c("div", [
                              _vm._v(
                                " " + _vm._s(scope.row.estimateCount) + " "
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.fileName"),
                  align: "center",
                  prop: "fileName",
                  width: "220",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.failedMessage"),
                  align: "center",
                  prop: "failedMessage",
                  "show-overflow-tooltip": "",
                  width: "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.operator"),
                  align: "center",
                  prop: "createUsername",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.startTime"),
                  align: "center",
                  prop: "startTime",
                  width: "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.endTime"),
                  align: "center",
                  prop: "endTime",
                  width: "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operationCenter.operate"),
                  align: "center",
                  fixed: "right",
                  prop: "operation",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.fileUrl
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "info" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDownload(
                                          scope.row.fileUrl
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Resource.download")) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        scope.row.status === 0 || scope.row.status === 1
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "danger",
                                      plain: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.cancelTaskClick(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("collectionCenter.cancelTask")
                                      ) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getData,
                  "size-change": function ($event) {
                    return _vm.getData(1)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }